import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Submotive2ActionsProps } from './props';
import { useSubmotive2ListActions } from './hook';

export const Submotive2ListActions = ({ id }: Submotive2ActionsProps) => {
    const { handleEdit } = useSubmotive2ListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
